import { render } from "./FehlerKorrigieren.vue?vue&type=template&id=60bf6652&scoped=true"
import script from "./FehlerKorrigieren.vue?vue&type=script&lang=js"
export * from "./FehlerKorrigieren.vue?vue&type=script&lang=js"

import "./FehlerKorrigieren.vue?vue&type=style&index=0&id=60bf6652&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60bf6652"]])

export default __exports__